webpackJsonp([1],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventemitter = __webpack_require__(15);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = new _eventemitter2.default();

exports.default = EE;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(12);

var _objectFitImages = __webpack_require__(14);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

var _ee = __webpack_require__(1);

var _ee2 = _interopRequireDefault(_ee);

var _panel = __webpack_require__(16);

var _noScroll = __webpack_require__(17);

var _noScroll2 = _interopRequireDefault(_noScroll);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(18);

__webpack_require__(19);

__webpack_require__(42);

__webpack_require__(43);

__webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(48 //css entry for dev - will be removed automagically for production version

//default js dependencies
);

(0, _panel.panelHandlers)();

_ee2.default.on('no-scroll-on', function () {
  console.info('noscroll on');
  _noScroll2.default.on();
});
_ee2.default.on('no-scroll-off', function () {
  console.info('noscroll off');
  _noScroll2.default.off();
});

_ee2.default.emit('event-name'

//additional js dependencies
// import "./plugins/mmenu"
// import "./plugins/validate"
// import "./plugins/gsap"

);(0, _objectFitImages2.default)('img', { watchMQ: true });

(0, _jquery2.default)(function () {
  (0, _jquery2.default)('a[href*="#"]:not([href="#"],[href*="#mm-"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = (0, _jquery2.default)(this.hash);
      target = target.length ? target : (0, _jquery2.default)('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        (0, _jquery2.default)('html, body').animate({
          scrollTop: target.offset().top - 0
        }, 400);
        return false;
      }
    }
  });
});

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _fastclick = __webpack_require__(13);

var _fastclick2 = _interopRequireDefault(_fastclick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fastclick2.default.attach(document.body);

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panelHandlers = panelHandlers;

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _ee = __webpack_require__(1);

var _ee2 = _interopRequireDefault(_ee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function panelIsOpen(panel) {
  return panel.hasClass('sliding-panel--open');
}

function removeBodyPanelClass(panel) {
  (0, _jquery2.default)("[data-panel-name]").not(panel).removeClass('sliding-panel--open');
  (0, _jquery2.default)('body').removeClass(function (index, className) {
    return (className.match(/(^|\s)panel-\S+/g) || []).join(' ');
  });
}

function closePanel(panel) {
  removeBodyPanelClass(panel);
  panel.removeClass('sliding-panel--open');

  _ee2.default.emit('no-scroll-off');
}
function openPanel(panel) {
  removeBodyPanelClass(panel);
  panel.addClass('sliding-panel--open');
  (0, _jquery2.default)('body').addClass('panel-is-open').addClass('panel-' + panel.attr('data-panel-name') + '-is-open');

  _ee2.default.emit('no-scroll-on');
}

function togglePanel(panel) {
  if (panelIsOpen(panel)) {
    closePanel(panel);
  } else {
    openPanel(panel);
  }
}

function targetInterfacesWithPanels(target) {
  if ((0, _jquery2.default)(target).closest("[data-panel-name]").length > 0 || (0, _jquery2.default)(target).closest("[data-panel-link]").length > 0) {
    return true;
  }
  return false;
}

function shouldClosePanel(allPanels) {
  for (var i = 0; i < allPanels.length; i++) {
    var panel = (0, _jquery2.default)(allPanels[i]);
    if (panelIsOpen(panel)) {
      closePanel(panel);
    }
  }
}

function panelHandlers() {
  var allPanels = (0, _jquery2.default)('[data-panel-name]');
  var allButtons = (0, _jquery2.default)('[data-panel-link]');
  (0, _jquery2.default)('.sliding-panel-toggle').on('click', function (e) {
    e.preventDefault();
    if (e.ctrlKey) {
      location.href = (0, _jquery2.default)(this).attr('href');
      console.warn('crtl click didn\'t not open in new tab. \n This feature is here for dev testing only! please delete at a later date.');
    }

    var button = (0, _jquery2.default)(this);
    var panelName = button.attr('data-panel-link');
    var panel = (0, _jquery2.default)('[data-panel-name="' + panelName + '"]');
    var action = button.attr('data-panel-action');

    switch (action) {
      case 'open':
        closePanel(panel);
        break;
      case 'close':
        openPanel(panel);
        break;
      case 'toggle':
        togglePanel(panel);
        break;
      default:
        togglePanel(panel);
    }
  });
  (0, _jquery2.default)(document).on('click', function (e) {
    if (!targetInterfacesWithPanels(e.target)) {
      shouldClosePanel(allPanels);
    }
    return;
  });
}

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function addFloatClass(wrapper) {
  wrapper.classList.add('should-float');
}

function removeFloatClass(wrapper) {
  wrapper.classList.remove('should-float');
}

function shouldUpdateClass(wrapper, input) {
  if (input.value !== '') {
    addFloatClass(wrapper);
  } else {
    removeFloatClass(wrapper);
  }
}

function registerFloatEventListners(wrapper, input) {
  input.addEventListener('focus', function (e) {
    addFloatClass(wrapper);
  }, false);
  input.addEventListener('blur', function (e) {
    shouldUpdateClass(wrapper, input);
  }, false);
}

(function () {
  var allFloatWrappers = document.querySelectorAll('.fe__wrapper--float');

  for (var i = 0; i < allFloatWrappers.length; i++) {
    var wrapper = allFloatWrappers[i];
    var input = wrapper.querySelectorAll('.fe__input')[0];

    shouldUpdateClass(wrapper, input);
    registerFloatEventListners(wrapper, input);
  }
})();

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _contactSubmit = __webpack_require__(20);

var _contactSubmit2 = _interopRequireDefault(_contactSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldShowElement(child, selectorToShow) {
  if (child.classList.contains(selectorToShow) || child.classList.contains('fe__wrapper--radio')) {
    return true;
  }
  return false;
}

function resetRequiredInputs(inputs) {
  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];
    input.removeAttribute('required');
  }
}
function setRequiredInputs(inputs) {
  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];
    if (input.getAttribute('data-required') === 'true') {
      input.setAttribute('required', 'required');
    }
  }
}

function showSelectedForm(form, checkedRadio) {
  var selectorToShow = checkedRadio;
  var children = form.querySelectorAll('.fe__wrapper');
  var child = void 0;
  var inputs = void 0;

  for (var c = 0; c < children.length; c++) {
    child = children[c];
    inputs = child.querySelectorAll('.fe__input');

    child.classList.add('hidden');
    resetRequiredInputs(inputs);
    if (shouldShowElement(child, selectorToShow)) {
      child.classList.remove('hidden');
      setRequiredInputs(inputs);
    }
  }
}

function shouldButtonShow(form, selectedRadio) {
  var button = form.querySelectorAll('button')[0];
  button.classList.add('btn-hidden');
  if (selectedRadio) {
    button.classList.remove('btn-hidden');
  }
}

function toggleForm(form, checkedRadio) {
  showSelectedForm(form, checkedRadio);
  shouldButtonShow(form, checkedRadio);
}

function addFormToggleListeners(form, radio) {
  radio.addEventListener('change', function () {
    toggleForm(form, radio.value);
  });
}

(function () {
  var forms = document.querySelectorAll('.dynamic-form');
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    var radios = form.querySelectorAll('input[type="radio"]');
    var checkedRadio = void 0;
    var radio = void 0;
    for (var l = 0; l < radios.length; l++) {
      radio = radios[l];
      if (radio.checked) {
        checkedRadio = radio.value;
      }
      addFormToggleListeners(form, radio);
    }
    toggleForm(form, checkedRadio);
    (0, _contactSubmit2.default)(form);
  }
})();

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formSerialize = __webpack_require__(21);

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _axios = __webpack_require__(22);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function preventSubmitOnEnterKey(e) {
  e = e || event;
  var txtArea = /textarea/i.test((e.target || e.srcElement).tagName);
  return txtArea || (e.keyCode || e.which || e.charCode || 0) !== 13;
}

function handleSuccess(form) {
  var successContainer = form.querySelectorAll('.success')[0];
  form.reset();
  successContainer.classList.add('submitted');

  //smooth not supported yet, but it will be in the future. This is good enough for now..
  document.body.scrollIntoView({ block: "start", behavior: "smooth" });
}
function handleErrors(form, errors, errorContainer) {
  var error = void 0;
  var error_messages = '';
  for (var i = 0; i < errors.length; i++) {
    error = errors[i];
    error_messages += '<p>' + error + '</p>';
  }
  if (error_messages === '') {
    error_messages = '<p>Unknown error, please try again.</p>';
  }
  errorContainer.classList.remove('no-errors');
  errorContainer.innerHTML = error_messages;
}

function handleFormSubmit(form) {
  var config = {
    headers: { 'X-REQUESTED-WITH': 'xmlhttprequest' }
  };
  form.onkeypress = preventSubmitOnEnterKey;
  form.onsubmit = function () {
    var formData = (0, _formSerialize2.default)(form);
    var errorContainer = form.querySelectorAll('.errors')[0];
    var button = form.querySelectorAll('button')[0];
    button.setAttribute('disabled', true);
    _axios2.default.post('/get-in-touch', formData, config).then(function (res) {
      button.removeAttribute('disabled');
      errorContainer.classList.add('no-errors');
      if (!res.data.status) {
        handleErrors(form, res.data.errors, errorContainer);
      } else {
        handleSuccess(form);
      }
    });
    return false;
  };
}

exports.default = handleFormSubmit;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ee = __webpack_require__(1);

var _ee2 = _interopRequireDefault(_ee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function openModal(id) {
  var modal = document.querySelectorAll('[data-video-modal="' + id + '"]')[0];
  modal.classList.add('video-modal--open');
  _ee2.default.emit('no-scroll-on');
}

function closeModals() {
  var modals = document.querySelectorAll('[data-video-modal]');
  for (var i = 0; i < modals.length; i++) {
    var modal = modals[i];
    modal.querySelectorAll('.video-modal-inner')[0].innerHTML = '';
    modal.classList.remove('video-modal--open');
  }
  _ee2.default.emit('no-scroll-off');
}

function modalIsOpen(modal) {
  return modal.classList.contains('video-modal--open');
}

function shouldCloseModal(allModals) {
  for (var i = 0; i < allModals.length; i++) {
    var modal = allModals[i];
    if (modalIsOpen(modal)) {
      closeModals(modal);
    }
  }
}

function initVideo(modal, id) {
  var iframe = document.createElement("iframe");
  var autoplay = '?autoplay=1';
  var related_no = '&rel=0';
  var src = '//www.youtube.com/embed/' + id + autoplay + related_no;
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "0";
  iframe.setAttribute('src', src);
  modal.querySelectorAll('.video-modal-inner')[0].innerHTML = '';
  modal.querySelectorAll('.video-modal-inner')[0].appendChild(iframe);
  return false;
}

function addClickListeners(videoAnchor) {
  videoAnchor.addEventListener('click', function (e) {
    var id = this.getAttribute('data-video-id');
    var modal = document.querySelectorAll('[data-video-modal="' + id + '"]')[0];
    e.preventDefault();
    openModal(id);
    initVideo(modal, id);
  });
}

(function () {
  var videoAnchors = document.querySelectorAll('.js-video-anchor');
  var videoAnchor = void 0;
  for (var i = 0; i < videoAnchors.length; i++) {
    videoAnchor = videoAnchors[i];
    addClickListeners(videoAnchor);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('video-modal-inner') && !e.target.classList.contains('js-video-anchor')) {
      shouldCloseModal(document.querySelectorAll('[data-video-modal]'));
    }
  });
})();

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _siema = __webpack_require__(44);

var _siema2 = _interopRequireDefault(_siema);

var _bsselect = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function registerNavClick(element, homeAboutSlider) {
  element.addEventListener('click', function () {
    homeAboutSlider.goTo(element.getAttribute('data-siema-index'));
    handleNavChange(element);
  });
}

function handleNavChange(element) {
  element.classList.add('is-active');

  var siblings = (0, _bsselect.getSiblings)(element);
  for (var i = 0; i < siblings.length; i++) {
    var _element = siblings[i];
    _element.classList.remove('is-active');
  }
}

if (document.querySelector('.about-sider__slide-container')) {

  var nav = document.querySelectorAll('.about-slider__nav-link');

  var homeAboutSlider = new _siema2.default({
    selector: '.about-sider__slide-container',
    duration: 200,
    easing: 'ease-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    loop: false,
    onInit: function onInit() {},
    onChange: function onChange() {
      handleNavChange(nav[homeAboutSlider.currentSlide]);
    }
  });

  for (var i = 0; i < nav.length; i++) {
    registerNavClick(nav[i], homeAboutSlider);
  }

  window.addEventListener("load", function () {
    homeAboutSlider.resizeHandler();
  }, false);
}

if (document.querySelector('.gallery-slider__container')) {
  var galleryWrapper = document.querySelector('.gallery-slider__wrapper');
  var SiemaGallery = new _siema2.default({
    selector: '.gallery-slider__container',
    perPage: 1,
    draggable: true,
    duration: 200,
    easing: 'ease-out',
    startIndex: 0,
    loop: false
  });

  var next = galleryWrapper.querySelector('.gallery-slider__next');
  var prev = galleryWrapper.querySelector('.gallery-slider__prev');

  prev.addEventListener('click', function () {
    return SiemaGallery.prev();
  });
  next.addEventListener('click', function () {
    return SiemaGallery.next();
  });

  window.addEventListener("load", function () {
    SiemaGallery.resizeHandler();
  }, false);
}

if (document.querySelector('.quote-slider')) {
  var quoteSlider = new _siema2.default({
    selector: '.quote-slider',
    perPage: 1,
    draggable: true,
    duration: 300,
    easing: 'ease-out',
    startIndex: 0,
    loop: true
  });

  setInterval(function () {
    quoteSlider.next();
    console.log(quoteSlider);
    console.log('next');
  }, 5000);

  window.addEventListener("load", function () {
    quoteSlider.resizeHandler();
  }, false);
}

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*jshint esversion: 6 */

var getChildren = exports.getChildren = function getChildren(n, skipMe) {
  var r = [];
  for (; n; n = n.nextSibling) {
    if (n.nodeType == 1 && n != skipMe) r.push(n);
  }return r;
};

var getSiblings = exports.getSiblings = function getSiblings(n) {
  return getChildren(n.parentNode.firstChild, n);
};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _velocityAnimate = __webpack_require__(47);

var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toggleAccordian(accordian) {
  var body = accordian.querySelectorAll('.accordian-item__body')[0];
  if (accordian.classList.contains('is-open')) {
    accordian.classList.remove('is-open');
    (0, _velocityAnimate2.default)(body, 'slideUp', { duration: 200 });
  } else {
    accordian.classList.add('is-open');
    (0, _velocityAnimate2.default)(body, 'slideDown', { duration: 200 });
  }
}

function addAccordianClickListener(accordian) {
  var toggle = accordian.querySelectorAll('.accordian-item__toggle')[0];
  toggle.addEventListener('click', function () {
    toggleAccordian(accordian);
  }, true);
}

(function () {

  var accordians = document.querySelectorAll('.accordian-item');

  for (var i = 0; i < accordians.length; i++) {
    var accordian = accordians[i];
    addAccordianClickListener(accordian);
  }
})();

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[11]);


// WEBPACK FOOTER //
// js/compiled/main.aa70a813f69e344b34bd.js